import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/opt-out")({
  beforeLoad: () => {
    throw redirect({ to: "/choices", replace: true, statusCode: 301 });
  },
});
